// @flow
export default (value: string): string => value.replace(/\D/g, '');
